import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/preview-audit")({
  component: lazyRouteComponent(() => import("./-pages/admin.preview-audit")),
  head: () => ({
    meta: [
      { title: "معاينة الهوامش والتباعد — Lecmo Admin" },
      { name: "description", content: "معاينة ثنائية (موبايل + ديسكتوب) لكلّ صفحة أو موضع بانر." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});
